{
  "name": "@prisma/internals",
  "version": "6.17.0",
  "description": "This package is intended for Prisma's internal use",
  "main": "dist/index.js",
  "types": "dist/index.d.ts",
  "repository": {
    "type": "git",
    "url": "https://github.com/prisma/prisma.git",
    "directory": "packages/internals"
  },
  "homepage": "https://www.prisma.io",
  "author": "Tim Suchanek <suchanek@prisma.io>",
  "bugs": "https://github.com/prisma/prisma/issues",
  "license": "Apache-2.0",
  "scripts": {
    "dev": "DEV=true tsx helpers/build.ts",
    "build": "tsx helpers/build.ts",
    "test": "dotenv -e ../../.db.env -- jest --silent",
    "prepublishOnly": "pnpm run build"
  },
  "files": [
    "README.md",
    "dist",
    "!**/libquery_engine*",
    "!dist/get-generators/engines/*",
    "scripts"
  ],
  "devDependencies": {
    "@babel/helper-validator-identifier": "7.25.9",
    "@opentelemetry/api": "1.9.0",
    "@swc/core": "1.11.5",
    "@swc/jest": "0.2.37",
    "@types/babel__helper-validator-identifier": "7.15.2",
    "@types/jest": "29.5.14",
    "@types/node": "18.19.76",
    "@types/resolve": "1.20.6",
    "archiver": "6.0.2",
    "checkpoint-client": "1.1.33",
    "cli-truncate": "4.0.0",
    "dotenv": "16.5.0",
    "empathic": "2.0.0",
    "escape-string-regexp": "5.0.0",
    "execa": "8.0.1",
    "fast-glob": "3.3.3",
    "find-up": "7.0.0",
    "fp-ts": "2.16.9",
    "fs-extra": "11.3.0",
    "global-directory": "4.0.0",
    "globby": "11.1.0",
    "identifier-regex": "1.0.0",
    "indent-string": "4.0.0",
    "is-windows": "1.0.2",
    "is-wsl": "3.1.0",
    "jest": "29.7.0",
    "jest-junit": "16.0.0",
    "kleur": "4.1.5",
    "mock-stdin": "1.0.0",
    "new-github-issue-url": "0.2.1",
    "node-fetch": "3.3.2",
    "npm-packlist": "5.1.3",
    "open": "7.4.2",
    "p-map": "4.0.0",
    "resolve": "1.22.10",
    "string-width": "7.2.0",
    "strip-indent": "4.0.0",
    "temp-dir": "2.0.0",
    "tempy": "1.0.1",
    "terminal-link": "4.0.0",
    "tmp": "0.2.3",
    "ts-pattern": "5.6.2",
    "ts-toolbelt": "9.6.0",
    "typescript": "5.4.5",
    "yarn": "1.22.22"
  },
  "dependencies": {
    "@prisma/config": "workspace:*",
    "@prisma/debug": "workspace:*",
    "@prisma/dmmf": "workspace:*",
    "@prisma/driver-adapter-utils": "workspace:*",
    "@prisma/engines": "workspace:*",
    "@prisma/fetch-engine": "workspace:*",
    "@prisma/generator": "workspace:*",
    "@prisma/generator-helper": "workspace:*",
    "@prisma/get-platform": "workspace:*",
    "@prisma/prisma-schema-wasm": "6.17.0-16.c0aafc03b8ef6cdced8654b9a817999e02457d6a",
    "@prisma/schema-engine-wasm": "6.17.0-16.c0aafc03b8ef6cdced8654b9a817999e02457d6a",
    "@prisma/schema-files-loader": "workspace:*",
    "arg": "5.0.2",
    "prompts": "2.4.2"
  },
  "peerDependencies": {
    "typescript": ">=5.1.0"
  },
  "peerDependenciesMeta": {
    "typescript": {
      "optional": true
    }
  },
  "sideEffects": false
}